<template>
  <h1 :is='level' v-html='text'/>
</template>

<script>
export default {
  props: ['level', 'text']
}
</script>

<style scoped>
  svg {
    height: 1.75em;
    vertical-align: middle;
    display: inline-block;
  }
</style>
